import React from 'react';
import {connect} from 'dva';
import './app.less';
import Tab from './tab'
import Content from './content'

class Pc extends React.Component {
    constructor(props) {
        super(props);
        if (window.parent.length > 0) {
            this.cssStyle = 'content';
        } else {
            this.cssStyle = 'content-full';
        }
    }

    // onClose = ()=> {
    //     window.parent.document.querySelector('#zhichi-feedback-layer').style.display = 'none';
    // };

    render() {
        return (
            <div className={this.cssStyle}>
                <Tab/>
                <Content/>
            </div>

        )
    }
}

const mapState = state => {
    const {ids, item, fieldConfig,ticketTypeList, sbumitFlag} = state.app;
    return {
        ids,
        item,
        fieldConfig,
        ticketTypeList,
        sbumitFlag
    };
};

export default connect(mapState)(Pc)
